import moment from 'moment';
import NepaliDate from 'nepali-date-converter';
import { useEffect, useState } from 'react';

// Convert English numbers to Nepali digits
const toNepaliDigits = (number) => {
    const nepaliDigits = ['०', '१', '२', '३', '४', '५', '६', '७', '८', '९'];
    return number.toString().replace(/\d/g, (digit) => nepaliDigits[digit]);
};

// Format Nepali date with correct weekday name and Nepali digits
const formatNepaliDate = (nepaliDate) => {
    const nepaliWeekdays = ['आइतवार', 'सोमवार', 'मङ्गलवार', 'बुधवार', 'बिहिवार', 'शुक्रवार', 'शनिवार'];
    const weekday = nepaliWeekdays[nepaliDate.getDay()];
    const year = toNepaliDigits(nepaliDate.getYear());
    const month = toNepaliDigits(nepaliDate.getMonth() + 1);
    const day = toNepaliDigits(nepaliDate.getDate());
    return `${weekday} ${year}/${month}/${day}`;
};

// Hook to convert English date to formatted Nepali date
export const useEnglishToNepaliDate = (englishDate) => {
    const nepaliDate = new NepaliDate(new Date(englishDate));
    return formatNepaliDate(nepaliDate);
};

// Hook to generate a week's worth of Nepali dates
export const useNepaliWeekDates = (startDate) => {
    const [nepaliDates, setNepaliDates] = useState([]);
    const [englishDates, setEnglishDates] = useState([]);

    useEffect(() => {
        const generateDates = () => {
            const englishDatesList = [];
            const nepaliDatesList = [];

            for (let i = 0; i < 7; i++) {
                const currentDate = moment(startDate).add(i, 'days');
                englishDatesList.push(currentDate.format('dddd, Do MMMM YYYY'));

                const nepDate = new NepaliDate(new Date(currentDate));
                nepaliDatesList.push({
                    englishDate: currentDate.format('YYYY-MM-DD'),
                    formattedDate: formatNepaliDate(nepDate),
                    year: nepDate.getYear(),
                    month: nepDate.getMonth() + 1,
                    day: nepDate.getDate(),
                    weekday: nepDate.getDay()
                });
            }

            setEnglishDates(englishDatesList);
            setNepaliDates(nepaliDatesList);
        };

        generateDates();
    }, [startDate]);

    return { englishDates, nepaliDates };
};